import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import styles from "./TechSummitRegistrationPage.module.css";
import axios from 'axios';
const TechSummitRegistrationPage = () => {
  const [form, setForm] = useState({
    role: "",
    availability: "",
    participantType: [],
    goals: [],
    heardFrom: "",
    suggestions: "",
  });
const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [isExisting, setIsExisting] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [eventDetails, setEventDetails] = useState({
    date: "",
    time: "",
    venue: ""
  });
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/registrations`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        const app = res.data;
        setIsExisting(true);
        setForm({
          ...app,
          participantType: app.participantType ? app.participantType.split('|') : [],
          goals: app.goals ? app.goals.split('|') : [],
        });
      })
      .catch(err => {
        console.error('Error fetching existing application:', err);
      });
  }, [token]);
  useEffect(() => {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/event/getdetails`)
        .then(res => {
          const { date, time, venue } = res.data;
          setEventDetails({ date, time, venue });
        })
        .catch(err => {
          console.error('Error fetching event details:', err);
        });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      const group = name;
      setForm((prev) => {
        const arr = prev[group] || [];
        return {
          ...prev,
          [group]: checked
            ? [...arr, value]
            : arr.filter((v) => v !== value),
        };
      });
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
  if (!form.role) newErrors.role = "Please select your role.";
  if (!form.availability) newErrors.availability = "Please select your availability.";
  if (!form.participantType.length) newErrors.participantType = "Please select at least one participant type.";
  if (!form.goals.length) newErrors.goals = "Please select at least one goal.";
  if (!form.heardFrom) newErrors.heardFrom = "Please select how you heard about the event.";

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return; // stop submission
  }

  setErrors({}); // clear errors if valid
    try {
      const url = isExisting
        ? `${process.env.REACT_APP_API_BASE_URL}/api/registrations/`
        : `${process.env.REACT_APP_API_BASE_URL}/api/registrations`;

      const res = await (isExisting
        ? axios.put(url, form, {
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          })
        : axios.post(url, form, {
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          }));

      if (res.status >= 200 && res.status < 300) {
        alert("✅ Registration saved successfully!")
      } else {
        setMessage("❌ Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setMessage("❌ Something went wrong. Please try again.");
    }
  };


  return (
    <div className={styles.pageContainer}>
      <div className={styles.container}>
        {/* Back Button */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className={styles.contentBox}
        >
          <motion.div
            className={styles.backButtonWrapper}
            whileHover={{ x: -5 }}
            onClick={() => navigate("/techsummit2025")}
          >
            &larr; Click here to view Event Details
          </motion.div>
          <h1 className={styles.title}>Udyog Connect AI Tech Summit</h1>
          <p className={styles.subtitle}>
            Udyog Connect is proudly organizing an AI Tech Summit for community
            (leaders, start-up entrepreneurs, Techies & College students). A great
            opportunity for <b>knowledge sharing, networking, branding & job search.</b>
          </p>

          <div className={styles.infoBox}>
           <p>📅 <b>Date:</b> {eventDetails.date || "To be announced soon!"}</p>
            <p>⏰ <b>Time:</b> {eventDetails.time || "To be announced soon!"}</p>
            <p>📍 <b>Event Address:</b> {eventDetails.venue || "To be announced soon!"}</p>
            <p>📧 <b>Contact us:</b> <a href="mailto:info@udyogconnect.org">info@udyogconnect.org</a></p>
          </div>

          <p className={styles.redText}>
            {isExisting
              ? "You are already registered for this event. Thank you!"
              : "Limited spots available – register soon to secure your place!"}
          </p>

          <div className={styles.highlightBox}>
            <b>** Complimentary Lunch will be provided for all registered participants **</b>
          </div>

          <hr className={styles.divider} />

          <h2 className={styles.formTitle}>
            {isExisting ? "Update Your Registration" : "Secure Your Spot"}
          </h2>

          <form onSubmit={handleSubmit} className={styles.form}>
            {/* Role */}
            <div className={styles.formGroup}>
              <label>Which of the following best describes you?</label>
              {["Industry leader / Executive", "Tech Practitioner", "Researcher / Academic", "Student / Emerging Professional"].map((opt) => (
                <label key={opt} className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="role"
                    value={opt}
                    checked={form.role === opt}
                    onChange={handleChange}
                  /> {opt}
                </label>
              ))}
              {errors.role && <p className={styles.errorText}>{errors.role}</p>}
            </div>

            {/* Availability */}
            <div className={styles.formGroup}>
              <label>Will you be able to attend this event in Dec-2025?</label>
              {["Yes, I'll be there", "Sorry, can't make it", "I will try, but not sure"].map((opt) => (
                <label key={opt} className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="availability"
                    value={opt}
                    checked={form.availability === opt}
                    onChange={handleChange}
                  /> {opt}
                </label>
              ))}
               {errors.availability && <p className={styles.errorText}>{errors.availability}</p>}
            </div>

            {/* Participant Type */}
            <div className={styles.formGroup}>
              <label>Please indicate your participant type</label>
              {["As a sponsor", "As a speaker", "As a tech attendee"].map((opt) => (
                <label key={opt} className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    name="participantType"
                    value={opt}
                    checked={form.participantType.includes(opt)}
                    onChange={handleChange}
                  /> {opt}
                </label>
              ))}
              {errors.participantType && <p className={styles.errorText}>{errors.participantType}</p>}
            </div>

            {/* Goals */}
            <div className={styles.formGroup}>
              <label>What are you hoping to get out of this event?</label>
              {[
                "Technology awareness",
                "Networking",
                "Want to brand my company or product",
                "Job opportunities",
                "Career growth",
              ].map((opt) => (
                <label key={opt} className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    name="goals"
                    value={opt}
                    checked={form.goals.includes(opt)}
                    onChange={handleChange}
                  /> {opt}
                </label>
              ))}
              {errors.goals && <p className={styles.errorText}>{errors.goals}</p>}
            </div>

            {/* Heard From */}
            <div className={styles.formGroup}>
              <label>How did you hear about this event?</label>
              <select
                name="heardFrom"
                value={form.heardFrom}
                onChange={handleChange}
              >
                <option value="">Select an option</option>
                {["Website", "Friend", "Newsletter", "Advertisement"].map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
              {errors.heardFrom && <p className={styles.errorText}>{errors.heardFrom}</p>}
            </div>

            {/* Suggestions */}
            <div className={styles.formGroup}>
              <label>Your suggestions matter! (optional)</label>
              <textarea
                name="suggestions"
                rows="4"
                value={form.suggestions}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className={styles.submitButton}>
              {isExisting ? "Update Registration" : "Submit Registration"}
            </button>

            {message && <p className={styles.message}>{message}</p>}
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default TechSummitRegistrationPage;
